module.exports = __webpack_public_path__ + "img/almenu_gomb_palyazatok_nyitott_aktiv.31f6c710.png";